import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[#F2EDE3] px-4 py-16">
      <motion.div
        className="flex max-w-md flex-col items-center text-center"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      >
        <p
          className="select-none text-[5.5rem] font-black leading-none tracking-tighter text-[#111111]/10"
          aria-hidden
        >
          404
        </p>
        <h1 className="mt-2 font-['Cabinet_Grotesk'] text-2xl md:text-3xl font-black tracking-tight text-[#111111]">
          Página no encontrada
        </h1>
        <p className="mt-3 text-base text-[#111111]/65 leading-relaxed max-w-sm">
          Esta ruta no existe o ya no está disponible. Si llegaste aquí por un
          enlace, puede que haya cambiado.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#a68a6d] hover:bg-[#8f7659] text-white text-base font-bold px-7 py-3.5 rounded-full transition-all hover:scale-105 shadow-[0_12px_30px_rgba(166,138,109,0.25)]"
          >
            Volver al inicio
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
          </Link>
          <a
            href="http://app.kubopayments.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#111111] hover:bg-[#2a2a2a] text-white text-base font-bold px-7 py-3.5 rounded-full transition-all hover:scale-105"
          >
            Ir al portal
            <ArrowUpRight className="w-4 h-4" strokeWidth={2.5} />
          </a>
        </div>
      </motion.div>
    </div>
  );
}
